import axios from "axios"

// 创建axios实例时应使用函数式初始化
let httpInstance = null

export const initHttp = () => {
  httpInstance = axios.create({
    // baseURL: window.$appConfig?.http || "/",
    // baseURL: "http://192.168.5.208:8080/api",
    baseURL: window.$http,
    timeout: 100000,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  })

  // 请求拦截器
  httpInstance.interceptors.request.use(
    (config) => {
      // 可在此处添加token等全局请求头
      // let token = window.localStorage.getItem("Authorization")
      // if (token) {
      //   config.headers["clientId"] = token
      // }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // 响应拦截器
  httpInstance.interceptors.response.use(
    (response) => {
      // 统一处理响应数据格式
      if (response.data.code >= 200 && response.data.code <= 500) {
        return response.data
      }
      return Promise.reject(response.data)
    },
    (error) => {
      console.log("服务器错误:", error.response?.status, error.message)
      return Promise.reject(error)
    }
  )

  return httpInstance
}

// 封装常用方法
export default {
  get: (url, params) => httpInstance.get(url, { params }),
  post: (url, data) => httpInstance.post(url, data),
  put: (url, data) => httpInstance.put(url, data),
  delete: (url) => httpInstance.delete(url),
}
